<template>
  <div class="stat inverse">
    Flagged Passes <span>{{ flaggedPassesLength }}</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "FlaggedPasses",
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      flaggedPassesLength: "dashboardCounters/flaggedPassesLength"
    })
  }
}
</script>

<style lang="scss" scoped></style>
